import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
var wrapTop = $(".ny-banner").offset().top;
var istrue = true;
var s = 100;

if (s > wrapTop  && istrue) {
    $(".timer").each(count);
    function count(a) {
        var b = $(this);
        a = $.extend({},
        a || {},
        b.data("countToOptions") || {});
        b.countTo(a)
    };
    istrue = false;
};

var swiper = new Swiper(".swiper", {
    slidesPerView: 5,
    spaceBetween: '3.64%',
    loop:true,
    speed:1000,
    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },
    breakpoints: {
      1366: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: '3.64%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 4,
        spaceBetween: '3.64%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: '3.64%',
      }
    } 
});